import { useEffect, useRef, useState } from "react";
import { useLoaderData } from "react-router-dom";
import { MdEdit, MdDelete, MdAdd, MdArrowBack, MdFilterAltOff, MdVisibility } from "react-icons/md";
import { toast } from "react-toastify";
import { Button } from "../components/Button";
import {
  GridToolbarContainer,
  GridToolbarQuickFilter,
} from "@mui/x-data-grid-pro";
import { useNavigate } from "react-router-dom";
import { Tooltip } from "@mui/material";

import ClickAwayListener from "@mui/material/ClickAwayListener";

import { DataGridBase } from "../components/DataGrid/DataGridBase";
import { SlOptionsVertical } from "react-icons/sl";
import Modal from "../components/Modal";
import {
  HiMiniArrowDownTray,
  HiOutlineCheck,
  HiOutlinePlus,
  HiOutlineTrash,
  HiOutlineXMark,
} from "react-icons/hi2";
import { PrincipalButton } from "../components/PrincipalButton";
import api from "../api/api";
import ExportCliente from "./Clienti/ExportCliente";
import { createPortal } from "react-dom";
import { knowAcces } from "../utils/utils";
import moment from "moment";

const TIPO_BADGE_CLASSES = {
  Z: "bg-blue-100 text-blue-700",
  I: "bg-green-100 text-green-700",
  B: "bg-purple-100 text-purple-700",
  G: "bg-amber-100 text-amber-700",
};

const TipoClienteBadge = ({ value }) => {
  const tipo = String(value || "").trim().toUpperCase();
  if (!tipo) return null;

  return (
    <span className={`px-2 py-1 rounded text-sm font-bold leading-none ${TIPO_BADGE_CLASSES[tipo] || "bg-gray-100 text-gray-600"}`}>
      {tipo}
    </span>
  );
};

const PERIODICITA_LABELS = {
  mensile: "Mensile",
  trimestrale: "Trimestrale",
  semestrale: "Semestrale",
  annuale: "Annuale",
  custom: "Personalizzata",
};

const PERIODICITA_FATT_LABELS = {
  mensile: "MEN",
  semestrale: "SEM",
  trimestrale: "TRI",
  annuale: "ANN",
  custom: "PER",
};

const formatPeriodicita = (value) => {
  const values = String(value || "")
    .split(",")
    .map((item) => item.trim())
    .filter(Boolean);
  return values.map((item) => PERIODICITA_LABELS[item] || item).join(", ");
};

const formatPeriodicitaFatt = (value) => {
  const values = String(value || "")
    .split(",")
    .map((item) => item.trim())
    .filter(Boolean);
  return values
    .map((item) => PERIODICITA_FATT_LABELS[item.toLowerCase()] || item.toUpperCase())
    .join(", ");
};

export const Clienti = ({ screenSize }) => {
  const navigate = useNavigate();
  const [openModal, setOpenModal] = useState(false);
  const anchorRef = useRef();
  const actionsButton = useRef();
  const [buttonVisible, setButtonVisible] = useState(false);

  const [openDelete, setOpenDelete] = useState(false);
  const [rowSel, setRowSel] = useState({});

  const [idRow, setIdRow] = useState();

  const [loading, setLoading] = useState(false);
  const [aziende, setAziende] = useState([]);
  const [anomalieMap, setAnomalieMap] = useState({}); // codice_univoco -> anomalie[]
  const [soloAnomalie, setSoloAnomalie] = useState(
    () => sessionStorage.getItem('clienti_soloAnomalie') === 'true'
  );

  // Ruoli utente corrente
  const isAdmin = knowAcces(['admin']);
  const isTL    = knowAcces(['team_leader']);
  const isPaghe = knowAcces(['paghe']);
  const isAssunzioni = knowAcces(['assunzioni']);
  const isAmministrazioneReadOnly = knowAcces(['amministrazione']) && !knowAcces(['admin', 'team_leader', 'paghe', 'assunzioni']);

  // Scope predefinito per ruolo
  // TL ha priorità su admin per lo scope predefinito (i TL sono spesso anche admin)
  const defaultScope = isTL
    ? 'mine'
    : isAdmin
    ? 'all'
    : isPaghe && isAssunzioni
    ? 'mine_assunzioni'
    : isPaghe
    ? 'mine'
    : isAssunzioni
    ? 'assunzioni'
    : 'all';

  const allowedScopes = isTL
    ? ['mine', 'team', 'all']
    : isAdmin
    ? ['all']
    : isPaghe && isAssunzioni
    ? ['mine_assunzioni', 'mine_assunzioni_tutti', 'all']
    : isPaghe
    ? ['mine', 'all']
    : isAssunzioni
    ? ['assunzioni', 'assunzioni_tutti', 'all']
    : ['all'];

  const [scope, setScope] = useState(
    () => {
      const savedScope = sessionStorage.getItem('clienti_scope');
      return allowedScopes.includes(savedScope) ? savedScope : defaultScope;
    }
  );
  const [mostraCessati, setMostraCessati] = useState(
    () => sessionStorage.getItem('clienti_mostraCessati') === 'true'
  );
  const [tipiFiltro, setTipiFiltro] = useState(new Set());
  const [gridKey, setGridKey] = useState(0);

  useEffect(() => {}, [screenSize]);
  useEffect(() => { sessionStorage.setItem('clienti_scope', scope); }, [scope]);
  useEffect(() => { sessionStorage.setItem('clienti_mostraCessati', mostraCessati); }, [mostraCessati]);
  useEffect(() => { sessionStorage.setItem('clienti_soloAnomalie', soloAnomalie); }, [soloAnomalie]);
  useEffect(() => { sessionStorage.removeItem('clienti_tipiFiltro'); }, []);

  const handleToggleButton = () => {
    setButtonVisible(!buttonVisible);
  };

  const toggleTipoFiltro = (tipo) => {
    setTipiFiltro((prev) => {
      const next = new Set(prev);
      next.has(tipo) ? next.delete(tipo) : next.add(tipo);
      return next;
    });
  };

  const resetFiltri = () => {
    sessionStorage.removeItem('clienti_scope');
    sessionStorage.removeItem('clienti_mostraCessati');
    sessionStorage.removeItem('clienti_soloAnomalie');
    sessionStorage.removeItem('clienti_tipiFiltro');
    sessionStorage.removeItem('datagrid_filter_clienti');
    setScope(defaultScope);
    setMostraCessati(false);
    setSoloAnomalie(false);
    setTipiFiltro(new Set());
    setGridKey((value) => value + 1);
  };

  const columns = [
    {
      field: "Azioni",
      headerName: "Azioni",
      width: screenSize > "768" ? 150 : 70,
      headerAlign: "center",
      align: "center",
      filterable: false,
      renderCell: (params) => {
        return (
          <>
            <div className="hidden md:flex flex-nowrap gap-2">
              {/* <Button
								className='delete-button'
								type='button'
								icon={<HiOutlineTrash className='button-icon' />}
								onClick={async () => {
									await setRowSel(params.row);
									setOpenDelete(true);
								}}
							/> */}
              <Button
                className="edit-button"
                type="button"
                icon={isAmministrazioneReadOnly ? <MdVisibility className="button-icon" /> : <MdEdit className="button-icon" />}
                onClick={async () => {
                  navigate("/DettaglioClienti", {
                    state: {
                      cliente: params.row,
                      nuovo: false,
                      clienti: aziende,
                    },
                  });
                }}
              />
            </div>
            {isAmministrazioneReadOnly ? (
              <div className="flex md:hidden w-full justify-center">
                <Button className="edit-button" type="button" icon={<MdVisibility className="button-icon" />}
                  onClick={() => navigate("/DettaglioClienti", { state: { cliente: params.row, nuovo: false, clienti: aziende } })} />
              </div>
            ) : <div className=" flex md:hidden md:flex-nowrap flex-wrap gap-2 w-full lg:w-2/3 float-right">
              <Button
                onClick={(e) => {
                  //imposto l'id della riga selezionata per fare comparire solo lei
                  setIdRow(params.row.id);
                  //rilevo l'altezza della riga
                  var rect = e.target.getBoundingClientRect();
                  //imposto altezza al Ref
                  actionsButton.current = rect.top;
                  handleToggleButton();
                }}
                className="relative flex items-center justify-center uppercase font-semibold md:font-bold text-white px-3 md:px-5 md:py-2.5 py-2 text-xs md:text-base rounded-lg text-center bg-success-100 hover:bg-success-200 focus:outline-none focus:ring-success-200 focus:ring-0 w-full"
                size="md"
                icon={
                  <SlOptionsVertical
                    className={`button-icon duration-500 transition-all text-miller-300 dark:text-miller-500`}
                  />
                }
              />
              {buttonVisible ? (
                <>
                  <ClickAwayListener onClickAway={handleToggleButton}>
                    <div
                      className={`absolute justify-end py-2 flex flex-wrap w-fit bg-white rounded-md shadow-sm shadow-slate-700 left-16 top-[${actionsButton.current}px]`}
                      ref={anchorRef}
                      id={params.row.id}
                      style={{
                        display: idRow === params.row.id ? "block" : "none",
                      }}
                    >
                      <Button
                        icon={<HiOutlineTrash className="button-icon" />}
                        className="nested-button"
                        text={"Elimina"}
                        onClick={async () => {
                          await setRowSel(params.row);
                          setOpenDelete(true);
                        }}
                      />
                      <Button
                        icon={<MdEdit className="button-icon" />}
                        className="nested-button"
                        text={"Modifica"}
                        onClick={() => {
                          navigate("/DettaglioClienti", {
                            state: { cliente: params.row, nuovo: false },
                          });
                        }}
                      />
                    </div>
                  </ClickAwayListener>
                </>
              ) : (
                <></>
              )}
            </div>}
          </>
        );
      },
    },
    {
      field: "_anomalie",
      headerName: "",
      width: 30,
      minWidth: 30,
      sortable: false,
      filterable: false,
      disableColumnMenu: true,
      resizable: false,
      renderCell: (params) => {
        const list = anomalieMap[params.row.codice_univoco];
        if (!list || !list.length) return null;
        return (
          <Tooltip enterDelay={100} enterNextDelay={0} title={
            <ul className="list-disc list-inside text-xs space-y-0.5">
              {list.map((a, i) => <li key={i}>{a}</li>)}
            </ul>
          }>
            <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100%' }}>
              <span style={{ width: 10, height: 10, borderRadius: '50%', background: '#ef4444', flexShrink: 0, cursor: 'help' }} />
            </span>
          </Tooltip>
        );
      },
    },
    {
      field: "tipologia_fatturazione",
      headerName: "Tipo",
      width: 80,
      minWidth: 70,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => <TipoClienteBadge value={params.value} />,
    },
    {
      field: "codice_univoco",
      headerName: "Cod. Univoco",
      width: 150,
      flex: screenSize > "768" ? 1 : 0,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "codice_fiscale",
      headerName: "Cod. Fiscale",
      width: 150,
      flex: screenSize > "768" ? 1 : 0,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "ragione_sociale",
      headerName: "Ragione Sociale",
      width: 150,
      flex: screenSize > "768" ? 1 : 0,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "gruppo_cliente",
      headerName: "Gruppo Aziende",
      width: 150,
      flex: screenSize > "768" ? 1 : 0,
      headerAlign: "center",
      align: "center",
    },

    {
      field: "media_cedolini",
      headerName: "N° Medio Cedolini",
      width: 150,
      flex: screenSize > "768" ? 1 : 0,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "referente_attivo_payroll",
      headerName: "Referente Payroll 1",
      width: 150,
      flex: screenSize > "768" ? 1 : 0,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "descrizione_assunzioni",
      headerName: "Referente Assunzioni 1",
      width: 150,
      flex: screenSize > "768" ? 1 : 0,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "ccnl_grouped",
      headerName: "CCNL",
      width: 150,
      flex: screenSize > "768" ? 1 : 0,
      headerAlign: "center",
      align: "center",
      getApplyQuickFilterFn: undefined, //to remove this column from quick filter
    },
    {
      field: "scadenza_consegna_paghe",
      headerName: "Scadenza consegna paghe",
      width: 150,
      flex: screenSize > "768" ? 1 : 0,
      headerAlign: "center",
      align: "center",
      getApplyQuickFilterFn: undefined,
    },
    {
      field: "presenze_differite",
      headerName: "Presenze differite",
      width: 130,
      flex: screenSize > "768" ? 1 : 0,
      headerAlign: "center",
      align: "center",
      getApplyQuickFilterFn: undefined,
      renderCell: (params) => (params.row.presenze_differite === "S" ? "Sì" : ""),
    },
    {
      field: "data_inizio_elaborazioni",
      headerName: "Data inizio elaborazioni",
      type: "date",
      width: 150,
      flex: screenSize > "768" ? 1 : 0,
      headerAlign: "center",
      align: "center",
      getApplyQuickFilterFn: undefined,
      valueGetter: (params) =>
        params.row.data_inizio_elaborazioni
          ? new Date(params.row.data_inizio_elaborazioni)
          : null,
      renderCell: (params) =>
        params.value ? moment(params.value).format("DD/MM/YYYY") : "",
    },
    {
      field: "data_fine_elaborazioni",
      headerName: "Data fine elaborazioni",
      type: "date",
      width: 150,
      flex: screenSize > "768" ? 1 : 0,
      headerAlign: "center",
      align: "center",
      getApplyQuickFilterFn: undefined, //to remove this column from quick filter
      valueGetter: (params) =>
        params.row.data_fine_elaborazioni
          ? new Date(params.row.data_fine_elaborazioni)
          : null,
      renderCell: (params) =>
        params.value ? moment(params.value).format("DD/MM/YYYY") : "",
    },
    isAdmin && {
      field: "periodicita_fatturazione",
      headerName: "FATT",
      width: 70,
      headerAlign: "center",
      align: "center",
      getApplyQuickFilterFn: undefined,
      renderCell: (params) => formatPeriodicitaFatt(params.value),
    },
  ].filter(Boolean);

  const handleDownloadCcnl = async () => {
    try {
      let response = await api.get(`/ccnl/attivi`, { responseType: "blob" });
      const url = window.URL.createObjectURL(
        new Blob([response.data], { type: "" })
      ); //prendo il file, lo rendo blob lo aggancio a un link e scarico

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "elenco_ccnl.xlsx");
      document.body.appendChild(link);
      link.click();
      toast.success("documenti ok");
    } catch {
      toast.error("errore nel download dei documenti");
    }
  };

  function CustomToolbar() {
    return (
      <GridToolbarContainer>
        <div className="w-full flex flex-wrap-reverse md:flex-nowrap justify-between md:space-x-5 mb-2 gap-y-1">
          <div className="flex md:flex-nowrap md:w-fit w-full flex-wrap justify-center md:justify-start gap-x-2 gap-y-1 items-center">
            <GridToolbarQuickFilter placeholder="Cerca..." />

            <div className="flex gap-1">
              {[
                ['Z', 'Zucchetti'],
                ['I', 'iiPay'],
                ['B', 'Bpoint'],
                ['G', 'Gruppo'],
              ].map(([tipo, label]) => {
                const active = tipiFiltro.has(tipo);
                return (
                  <button
                    key={tipo}
                    type="button"
                    title={label}
                    onClick={() => toggleTipoFiltro(tipo)}
                    className={`px-2.5 py-1 rounded text-xs font-bold border transition-colors ${
                      active
                        ? `${TIPO_BADGE_CLASSES[tipo]} border-transparent`
                        : 'bg-white text-gray-500 border-gray-300 hover:border-gray-400'
                    }`}
                  >
                    {tipo}
                  </button>
                );
              })}
            </div>

            {/* Toggle scope: TL → mine/team/all; paghe → mine/all */}
            {isTL && (
              <div className="flex gap-1">
                {[['mine', 'Solo miei'], ['team', 'Mio team'], ['all', 'Tutti']].map(([s, label]) => (
                  <button key={s} type="button" onClick={() => setScope(s)}
                    className={`px-2 py-1 rounded text-xs font-medium border transition-colors ${scope === s ? 'bg-blue-100 border-blue-400 text-blue-700' : 'bg-white border-gray-300 text-gray-600 hover:border-blue-200'}`}>
                    {label}
                  </button>
                ))}
              </div>
            )}
            {isPaghe && isAssunzioni && !isTL && !isAdmin && (
              <div className="flex gap-1">
                {[['mine_assunzioni', 'Solo miei'], ['mine_assunzioni_tutti', 'Miei + non assegnati'], ['all', 'Tutti']].map(([s, label]) => (
                  <button key={s} type="button" onClick={() => setScope(s)}
                    className={`px-2 py-1 rounded text-xs font-medium border transition-colors ${scope === s ? 'bg-blue-100 border-blue-400 text-blue-700' : 'bg-white border-gray-300 text-gray-600 hover:border-blue-200'}`}>
                    {label}
                  </button>
                ))}
              </div>
            )}
            {isPaghe && !isAssunzioni && !isTL && !isAdmin && (
              <div className="flex gap-1">
                {[['mine', 'Solo miei'], ['all', 'Tutti']].map(([s, label]) => (
                  <button key={s} type="button" onClick={() => setScope(s)}
                    className={`px-2 py-1 rounded text-xs font-medium border transition-colors ${scope === s ? 'bg-blue-100 border-blue-400 text-blue-700' : 'bg-white border-gray-300 text-gray-600 hover:border-blue-200'}`}>
                    {label}
                  </button>
                ))}
              </div>
            )}
            {isAssunzioni && !isPaghe && !isTL && !isAdmin && (
              <div className="flex gap-1">
                {[['assunzioni', 'Solo miei'], ['assunzioni_tutti', 'Miei + non assegnati'], ['all', 'Tutti']].map(([s, label]) => (
                  <button key={s} type="button" onClick={() => setScope(s)}
                    className={`px-2 py-1 rounded text-xs font-medium border transition-colors ${scope === s ? 'bg-blue-100 border-blue-400 text-blue-700' : 'bg-white border-gray-300 text-gray-600 hover:border-blue-200'}`}>
                    {label}
                  </button>
                ))}
              </div>
            )}

            {/* Toggle cessati */}
            <button
              type="button"
              onClick={() => setMostraCessati((v) => !v)}
              className={`px-2 py-1 rounded text-xs font-medium border transition-colors ${mostraCessati ? 'bg-orange-100 border-orange-400 text-orange-700' : 'bg-white border-gray-300 text-gray-600 hover:border-orange-300'}`}
            >
              {mostraCessati ? 'Nascondi cessati' : 'Mostra cessati'}
            </button>

            {/* Toggle solo anomalie */}
            <button
              type="button"
              onClick={() => setSoloAnomalie((v) => !v)}
              className={`px-2 py-1 rounded text-xs font-medium border transition-colors ${soloAnomalie ? 'bg-red-100 border-red-400 text-red-700' : 'bg-white border-gray-300 text-gray-600 hover:border-red-300'}`}
            >
              {soloAnomalie ? '● Solo anomalie' : '○ Solo anomalie'}
            </button>

            <button
              type="button"
              onClick={resetFiltri}
              className="inline-flex items-center gap-1 rounded border border-gray-300 bg-white px-2 py-1 text-xs font-medium text-gray-600 transition-colors hover:border-blue-300 hover:text-blue-700"
            >
              <MdFilterAltOff aria-hidden="true" />
              Reset filtri
            </button>
          </div>
          <div className="flex justify-center md:justify-end md:mx-0 mx-auto gap-2">
            <Button
              className="success-button"
              size="md"
              text={"Scarica CCNL clienti"}
              icon={<HiMiniArrowDownTray className="button-icon" />}
              onClick={handleDownloadCcnl}
            />
            <Button
              className="success-button"
              size="md"
              text={"Esporta anomalie clienti"}
              icon={<HiMiniArrowDownTray className="button-icon" />}
              onClick={handleDownloadAnomalie}
            />
            <Button
              className="success-button"
              size="md"
              text={"Esporta recap clienti"}
              icon={<HiMiniArrowDownTray className="button-icon" />}
              onClick={() => setOpenModal(true)}
            />
          </div>
        </div>
      </GridToolbarContainer>
    );
  }

  const handleDownloadAnomalie = async () => {
    try {
      const resp = await api.get("/aziende/anomalie/export", { responseType: "blob" });
      const url = window.URL.createObjectURL(new Blob([resp.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "anomalie_clienti.xlsx");
      document.body.appendChild(link);
      link.click();
      link.remove();
      toast.success("Export anomalie completato");
    } catch {
      toast.error("Errore nel download delle anomalie");
    }
  };

  const loadAziende = async (currentScope, includeCessati) => {
    const params = `scope=${currentScope}&cessati=${includeCessati ? '1' : '0'}`;
    const resp = await api.get(`/aziende/dashboard?${params}`);
    setAziende(resp.data);
  };

  // Anomalie: caricamento unico all'avvio (non dipende da scope/cessati)
  useEffect(() => {
    api.get("/aziende/anomalie").then((resp) => {
      const map = {};
      (resp.data || []).forEach((r) => { map[r.codice_univoco] = r.anomalie; });
      setAnomalieMap(map);
    }).catch(() => {});
  }, []);

  // Ricarica clienti al cambio di scope o filtro cessati
  useEffect(() => {
    loadAziende(scope, mostraCessati);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [scope, mostraCessati]);

  const rowsFiltrate = aziende
    .filter((a) => tipiFiltro.size === 0 || tipiFiltro.has(String(a.tipologia_fatturazione || "").toUpperCase()))
    .filter((a) => !soloAnomalie || anomalieMap[a.codice_univoco]?.length);

  return (
    <>
      {openModal &&
        createPortal(
          <ExportCliente
            setOpenModal={setOpenModal}
            //codice_azienda={cliente.codice_univoco}
          />,
          document.getElementById("portalModal")
        )}
      <div className="page-container">
        <Modal
          isOpen={openDelete}
          closeButton={() => setOpenDelete(false)}
          headerText={`Eliminazione Cliente`}
          rightButtons={
            <>
              <Button
                className="success-button"
                size="md"
                text={"Conferma"}
                icon={<HiOutlineCheck className="button-icon" />}
                //onClick={handleSave}
              />
            </>
          }
          leftButtons={
            <>
              <Button
                className="error-button"
                size="md"
                text={"Annulla"}
                icon={<HiOutlineXMark className="button-icon" />}
                onClick={() => setOpenDelete(false)}
              />
            </>
          }
        >
          <h3 className="text-center">
            Sicuro di voler eliminare: <b>{rowSel.codice_univoco}</b>?
          </h3>
        </Modal>

        <div className="w-full md:h-[85vh] h-[85vh] relative el-container">
          <DataGridBase
            key={gridKey}
            storageKey="clienti"
            defaultHiddenColumns={{ ccnl_grouped: false, data_fine_elaborazioni: false }}
            slots={{ toolbar: CustomToolbar }}
            disableRowSelectionOnClick={true}
            columns={columns}
            rows={rowsFiltrate}
            getRowId={(r) => r.codice_univoco}
          />
        </div>
      </div>
    </>
  );
};
